/**
 * Tutorial guidato della pagina Blog.
 *
 * La pagina fa due cose in una: in alto la configurazione del servizio, sotto
 * l'elenco degli articoli. Il tutorial apre il riquadro della configurazione per
 * mostrarne i campi, e `stopBlogTour` lo richiude - ma solo se a spalancarlo e'
 * stato lui.
 *
 * I tre pallini della riga si raccontano illuminando il pulsante e non la voce
 * dentro il menu: un menu aperto dal tutorial si richiude da solo, perche' il click
 * programmatico e quello su "Avanti" arrivano a `document` a un soffio di distanza.
 */
const SCOPE = '[data-tour-scope="blog"]';

const at = name => `${SCOPE} [data-tour="${name}"]`;

let opened = false;

const visible = selector => {
	const element = document.querySelector(selector);

	return !!element && element.getClientRects().length > 0;
};

/** Apre il riquadro della configurazione, se non e' gia' aperto. */
function openSettings() {
	if (visible(at('settings'))) return;

	const toggle = document.querySelector(at('expand'));

	if (toggle) {
		opened = true;
		toggle.click();
	}
}

/** Richiude il riquadro aperto dal tutorial. */
export function stopBlogTour() {
	if (!opened) return;

	opened = false;

	if (visible(at('settings'))) {
		document.querySelector(at('expand'))?.click();
	}
}

export function createBlogTourSteps() {
	return [
		{
			body: "Il blog del sito si scrive da solo: l'intelligenza artificiale prepara gli articoli partendo dai tuoi prodotti e dalle regole che scrivi qui sopra, e tu li rileggi e li pubblichi. Questa pagina fa due cose - in alto la configurazione del servizio, sotto l'elenco degli articoli.",
			key: 'intro',
			placement: 'bottom',
			target: at('tutorial'),
			title: 'Il blog',
		},
		{
			body: "L'interruttore accende il servizio blog, e salva subito. Spento non si generano piu' articoli nuovi; quelli gia' scritti restano dove sono.",
			key: 'switch',
			placement: 'left',
			target: at('switch'),
			title: 'Accendere il servizio',
		},
		{
			body: "Regole e impostazioni apre la configurazione: quanti articoli al mese, in che lingua condividerli, e soprattutto le tre caselle di regole - come scrivere l'articolo in anteprima, come svilupparne il dettaglio, come immaginare l'immagine. Quelle regole sono le istruzioni che l'intelligenza artificiale segue: piu' sono precise, meno c'e' da correggere dopo.",
			before: stopBlogTour,
			key: 'expand',
			placement: 'right',
			target: at('expand'),
			timeout: 400,
			title: 'Aprire la configurazione',
		},
		{
			body: 'Qui dentro si dice anche dove condividere quello che esce - Facebook, Instagram, TikTok - e si salva con il pulsante in fondo al riquadro. Salva impostazioni registra la configurazione, non genera niente.',
			before: openSettings,
			key: 'settings',
			placement: 'right',
			target: at('settings'),
			timeout: 600,
			title: 'Le regole e la condivisione',
		},
		{
			body: "Attenzione a questo pulsante: non apre una scheda vuota da compilare, fa scrivere all'intelligenza artificiale nuovi articoli seguendo le regole qui sopra. Prima di partire chiede conferma. Serve che il servizio blog sia acceso e configurato; se manca, risponde che il blog non e' configurato.",
			before: stopBlogTour,
			key: 'add',
			placement: 'left',
			target: at('add'),
			title: 'Far scrivere nuovi articoli',
		},
		{
			body: "La ricerca filtra per titolo (da tre caratteri), e i chip degli stati restringono l'elenco a una fase sola: Bozza, Creato, Pubblicato, Annullato. Ricerca, stato e pagina restano nell'indirizzo: ricaricando o tornando da un articolo li ritrovi.",
			key: 'filters',
			placement: 'bottom',
			target: at('filters'),
			title: 'Cercare e filtrare',
		},
		{
			body: "La tabella mostra l'immagine, il titolo con il prodotto a cui e' collegato, lo stato e il giorno di pubblicazione; il + accanto ai tre pallini apre l'anteprima. Un articolo appena generato non e' ancora online: ci va solo quando lo porti a Pubblicato.",
			key: 'table',
			placement: 'top',
			target: at('table'),
			title: 'Leggere l’elenco',
		},
		{
			body: "I tre pallini a inizio riga aprono Modifica ed Elimina, che chiede conferma. Modifica porta alla pagina dell'articolo, dove si rilegge il testo, si cambia l'immagine e si decide quando pubblicarlo: ha un tutorial suo.",
			key: 'row-menu',
			placement: 'right',
			target: at('row-menu'),
			title: 'Rileggere un articolo',
		},
		{
			body: "L'elenco arriva una pagina per volta dal server: da qui cambi pagina e quante righe vedere. Pagina, righe e ordinamento restano nell'indirizzo: ricaricando o tornando da una scheda li ritrovi.",
			key: 'pagination',
			placement: 'top',
			target: `${SCOPE} .v-data-footer`,
			timeout: 400,
			title: 'Sfogliare gli articoli',
		},
	];
}
